module.exports = __webpack_public_path__ + "img/avatar3.764584f2.png";